/* eslint-disable react-hooks/exhaustive-deps */
import ItineraryContent from "@components/itinerary/ItineraryContent";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import { Action, memberPnrInfo, pnrInformation, recentPnrInformation } from "@service/proxy";
import Translate from "@service/Translate";
import { handleRSVError } from "@utilize/Util";
import { getPrint } from "@utilize/Window";
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

const ItineraryEn: FC = () => {
    const { tr } = Translate;
    const dispatch = useDispatch();
    const query = new URLSearchParams(useLocation().search);
    const { user } = useSelector((state: IAppState) => ({ user: state.user }));

    useEffect(() => {
        const transactionIdentifier = query.get("transactionId");
        const pnr = query.get("pnr") || undefined;
        const departureDate = +(query.get("date") || "0") || undefined;
        const contactLastName = query.get("name") || undefined;
        dispatch<IAppAction>({ type: AppAction.Preloader, payload: { preloader: { show: true, message: tr("payment_preparing_ticket") } } });
        (transactionIdentifier ? recentPnrInformation(Action.POST, { data: { transactionIdentifier } }) :
            user.guid ? memberPnrInfo(Action.POST, { data: { pnr, departureDate, contactLastName } }) :
                pnrInformation(Action.POST, { data: { pnr, departureDate, contactLastName } })
        )
            .then((response) => {
                dispatch<IAppAction>({ type: AppAction.PnrInfo, payload: { pnrInfo: response.content } });
                setTimeout(() => {
                    getPrint();
                }, 1000);
            })
            .catch((err) => {
                handleRSVError(err);
            })
            .finally(() => {
                dispatch<IAppAction>({ type: AppAction.Preloader, payload: { preloader: { show: false, message: "" } } });
            })
    }, []);

    return (
        <div id="itineraryEn" className="itinerary itinerary-en">
            <ItineraryContent />
        </div>
    )
}

export default ItineraryEn;
